import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueI18n from 'vue-i18n';
import messages from './i18n';
import Vuetify from 'vuetify';
import GAuth from 'vue-google-oauth2'
import 'vuetify/dist/vuetify.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(VueI18n);
Vue.use(Vuetify, {
  iconfont: 'md'
});

const i18n = new VueI18n({
  locale: 'en',
  messages,
});

const gauthOption = {
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  scope: 'profile email https://www.googleapis.com/auth/cloud-platform https://www.googleapis.com/auth/firebase',
  prompt: 'select_account'
};
Vue.use(GAuth, gauthOption);


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
